(function($) {

    var membershipPaymentFormValid = true;
    var membershipPaymentFormNextStep = $('.membership-payment-form-next-step');
    var membershipPaymentFormSubmit = $('.membership-payment-form-submit');
    var membershipPaymentRequiredFields = $('.membership-payment-form-wrap .required');
    // var amountField = $('[name=membership-payment-amount]');
    var membershipPaymentDepartmentAmount = 0;
    var membershipPaymentCustomDepartmentAmount = 0;
    var membershipPaymentCustomDepartmentAmountField = $('input[name=membership-payment-custom-department]');
    var membershipPaymentCustomPartyAmount = 0;
    var membershipPaymentCustomPartyAmountField = $('input[name=membership-payment-custom-party]');



    $('.open-membership-payment-first-step-notice').on('click', function () {
        $('.modal-membership-payment-first-step-notice').addClass('active');
        $('body').addClass('overflow-hidden');
    });

    $('.open-membership-payment-second-step-notice').on('click', function () {
        $('.modal-membership-payment-second-step-notice').addClass('active');
        $('body').addClass('overflow-hidden');
    });

    function matchStart(params, data) {
        params.term = params.term || '';
        if (data.text.toUpperCase().indexOf(params.term.toUpperCase()) == 0) {
            return data;
        }
        return false;
    }

    $(document).ready(function() {
        $('.membership-year-dropdown').select2({
            width: 'auto',
            minimumResultsForSearch: -1,
            placeholder: $(this).data('placeholder')
        });
        $('.membership-department-dropdown, .bank-department-dropdown').select2({
            width: 'auto',
            // minimumResultsForSearch: -1,
            placeholder: $(this).data('placeholder'),
            language: {
                noResults: function () {
                    return "Rezultatų nerasta";
                }
            },
            matcher: function(params, data) {
                return matchStart(params, data);
            }
        });
    });

    function validateEmail(email) {
        var re = /\S+@\S+\.\S+/;
        return re.test(email);
    }

    function updateSummary() {
        membershipPaymentFormSubmit.html('Paremti — ' + (+membershipPaymentDepartmentAmount + +membershipPaymentCustomDepartmentAmount + +membershipPaymentCustomPartyAmount).toFixed(2) + ' €');
        $('.membership-payment-full-amount').html((+membershipPaymentDepartmentAmount + +membershipPaymentCustomDepartmentAmount + +membershipPaymentCustomPartyAmount).toFixed(2) + ' €');
        $('.membership-payment-department-amount').html(membershipPaymentDepartmentAmount + ' €');
        $('.membership-payment-custom-department-amount').html(membershipPaymentCustomDepartmentAmount + ' €');
        $('.membership-payment-custom-party-amount').html(membershipPaymentCustomPartyAmount + ' €');
    }

    $('.membership-department-dropdown').on('change', function () {
        membershipPaymentDepartmentAmount = this.options[this.selectedIndex].getAttribute('data-fee');
        $('.membership-payment-amount').css('opacity', 1).find('.amount').html(membershipPaymentDepartmentAmount + ' €');
        updateSummary();
    });

    $('.bank-department-dropdown').on('change', function () {
        var fee = this.options[this.selectedIndex].getAttribute('data-fee');
        var message = this.options[this.selectedIndex].getAttribute('data-message');
        var account = this.options[this.selectedIndex].getAttribute('data-account');

        $('.department-info .dep-fee').html(fee);
        $('.department-info .dep-message').html(message);
        $('.department-info .dep-account').html(account);

        $('.department-info').show();
    });

    membershipPaymentCustomDepartmentAmountField.on('keyup', function () {
        if (membershipPaymentCustomDepartmentAmountField.val()) {
            membershipPaymentCustomDepartmentAmount = membershipPaymentCustomDepartmentAmountField.val();
        } else {
            membershipPaymentCustomDepartmentAmount = 0;
        }

        updateSummary();
    });
    membershipPaymentCustomPartyAmountField.on('keyup', function () {
        if (membershipPaymentCustomPartyAmountField.val()) {
            membershipPaymentCustomPartyAmount = membershipPaymentCustomPartyAmountField.val();
        } else {
            membershipPaymentCustomPartyAmount = 0;
        }

        updateSummary();
    });

    membershipPaymentFormNextStep.on('click', function() {
        membershipPaymentFormValid = true;
        $('.membership-payment-form-wrap .input-wrap').removeClass('has-error');
        $('.membership-payment-form-wrap .input-wrap .input-error').hide();
        $('#membership-agree').parent().removeClass('has-error');

        membershipPaymentRequiredFields.each(function (ind, val) {
            if ($(val).val() === '') {
                membershipPaymentFormValid = false;
                $(val).parent().addClass('has-error').find('.input-error.error-required').show();
            } else if ($(val).attr('name') === 'membership-code') {
                if ($(val).val().length !== 11) {
                    membershipPaymentFormValid = false;
                    $(val).parent().addClass('has-error').find('.input-error.error-invalid').show();
                }
            } else if ($(val).attr('name') === 'membership-email') {
                if (!validateEmail($(val).val())) {
                    membershipPaymentFormValid = false;
                    $(val).parent().addClass('has-error').find('.input-error.error-invalid').show();
                }
            }

            if (!$('#membership-agree').is(':checked')) {
                membershipPaymentFormValid = false;
                $('#membership-agree').parent().addClass('has-error');
            }
        });

        if (membershipPaymentFormValid) {
            $('.content-switcher .content-switch').removeClass('active');
            $('.content-switcher .content-switch[data-tab=2]').addClass('active');

            $('.content-tab').removeClass('active');
            $('.content-tab-2').addClass('active');

            $('html, body').animate({scrollTop: 0}, 400);
        } else {
            $('html, body').animate({scrollTop: $('body').find('.has-error').offset().top - 200}, 400);
        }
    });

    membershipPaymentFormSubmit.on('click', function () {
        membershipPaymentFormSubmit.addClass('loading');

        var data = {
            'action' : 'get_membership_payment_link',
            'amount' : (+membershipPaymentDepartmentAmount + +membershipPaymentCustomDepartmentAmount + +membershipPaymentCustomPartyAmount).toFixed(2),
            'department' : $('[name=membership-department]').val(),
            'amount-department' : membershipPaymentDepartmentAmount,
            'amount-custom-department' : membershipPaymentCustomDepartmentAmount,
            'amount-custom-party' : membershipPaymentCustomPartyAmount,
            'method' : $('[name=payment]:checked').val(),
            'name' : $('[name=membership-name]').val(),
            'surname' : $('[name=membership-surname]').val(),
            'code' : $('[name=membership-code]').val(),
            'email' : $('[name=membership-email]').val(),
            'year' : $('[name=membership-year]').val(),
        };

        $.get(postmpwp.ajax_url, data, function(response){
            if (response.success) {
                window.location = response.data;
            }
        });
    });

})( jQuery );